import {Pipe, PipeTransform} from '@angular/core';
import {DateToDatePipe} from './pipe-date-to-date';

@Pipe({name: 'date_to_datetime_pipe'})
export class DateToDateTimePipe implements PipeTransform {
  public transform(date: Date, shortYear: boolean = false): string {
    if (date === undefined) {
      return '';
    }

    const datePart: string = DateToDatePipe.transform(date, shortYear);

    let hour: string = `${date.getUTCHours()}`;
    if (hour.length === 1) {
      hour = `0${hour}`;
    }

    let minute: string = `${date.getUTCMinutes()}`;
    if (minute.length === 1) {
      minute = `0${minute}`;
    }

    return `${datePart} ${hour}:${minute}`;
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/pipes/pipe-date-to-datetime.ts